import { concatPath, moment, TimeFormat } from '@feathr/hooks';
import type { TConstraints, TOptionalConstraint } from '@feathr/rachis';

import { MailrailSingleSendEmailCampaign } from './mailrail_single_send';
import type { IMailrailPartnerMessage } from './types';

type PartialAttrs = Partial<IMailrailPartnerMessage>;

export class MailrailPartnerMessage extends MailrailSingleSendEmailCampaign {
  public override get constraints(): TConstraints<IMailrailPartnerMessage> {
    return {
      ...super.constraints,
      'participation.mode': {
        presence: {
          allowEmpty: false,
          message: '^Please choose a partner selection mode.',
        },
      },
      'participation.partner_ids': (_: string[], attributes: PartialAttrs): TOptionalConstraint => {
        if (attributes.participation?.['mode'] === 'manual') {
          return {
            presence: {
              allowEmpty: false,
              message: '^You must specify at least one recipient if you choose "select partners".',
            },
          };
        }
        return undefined;
      },
    };
  }

  public override getItemUrl(pathSuffix?: string): string {
    return concatPath(`/projects/${this.get('event')}/partners/messages/${this.id}`, pathSuffix);
  }

  public getItemLabel(): string {
    if (this.get('name')) {
      return this.get('name');
    }
    const sendAt = this.get('date_start');
    const formattedDate = sendAt ? ` (${moment.utc(sendAt).format(TimeFormat.shortDateTime)})` : '';
    return `Unnamed message${formattedDate}`;
  }

  public override get name(): string {
    return this.get('name', '').trim() || `Unnamed Message`;
  }
}
